import { render, staticRenderFns } from "./AddAmong.vue?vue&type=template&id=5d19bec8&scoped=true&"
import script from "./AddAmong.vue?vue&type=script&lang=js&"
export * from "./AddAmong.vue?vue&type=script&lang=js&"
import style0 from "./AddAmong.vue?vue&type=style&index=0&id=5d19bec8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d19bec8",
  null
  
)

export default component.exports